import { render, staticRenderFns } from "./PowerBiViewDisplay.vue?vue&type=template&id=275493cb&scoped=true"
import script from "./PowerBiViewDisplay.vue?vue&type=script&lang=js"
export * from "./PowerBiViewDisplay.vue?vue&type=script&lang=js"
import style0 from "./PowerBiViewDisplay.vue?vue&type=style&index=0&id=275493cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275493cb",
  null
  
)

export default component.exports